import { APIService } from "@/services/api";
import {
  ReadSurveyTemplate,
  WriteSurveyTemplate,
} from "@/types/survey-template";
import { API } from "@/lib/api";

const SurveyTemplatesService = new APIService<
  ReadSurveyTemplate,
  WriteSurveyTemplate
>(API.SurveysTemplates);

export const fetchSurveyTemplateList = SurveyTemplatesService.getList;
export const fetchSurveyTemplate = SurveyTemplatesService.get;
export const createSurveyTemplate = SurveyTemplatesService.post;
export const updateSurveyTemplate = SurveyTemplatesService.patch;
